<ion-button
  class="btn-group-start"
  fill="outline"
  [color]="buttonColor"
  (click)="openECmr(freight())"
  libClickStopPropagation
>
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/content_paste_FILL0_wght400_GRAD0_opsz24.svg"
  ></ion-icon>
  {{ 'files.ecmr' | translate }}
</ion-button>

<ion-button
  class="btn-group-end"
  id="btn-view-docs"
  fill="outline"
  [color]="buttonColor"
  (click)="viewDocs()"
  libClickStopPropagation
>
  <ion-icon
    slot="end"
    aria-label="View more options"
    src="../assets/material-symbols/expand_more_FILL0_wght400_GRAD0_opsz24.svg"
  ></ion-icon>
</ion-button>
